import React, { memo, useMemo } from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
    activeClassName,
    breakLabel,
    breakClassName,
    containerClassName,
    marginPagesDisplayed,
    nextLabel,
    onPageChange,
    itemsCount,
    itemsPerPage,
    page,
    pageRangeDisplayed,
    previousLabel,
}) => {
    const pageCount = useMemo(
        () => Math.ceil(itemsCount / itemsPerPage),
        [itemsCount],
    );

    const handlePageChange = (event) => {
        onPageChange(event.selected + 1);
    };

    return (
        <ReactPaginate
            activeClassName={activeClassName}
            breakLabel={breakLabel}
            breakClassName={breakClassName}
            containerClassName={containerClassName}
            marginPagesDisplayed={marginPagesDisplayed}
            nextLabel={nextLabel}
            onPageChange={handlePageChange}
            pageCount={pageCount}
            pageRangeDisplayed={pageRangeDisplayed}
            previousLabel={previousLabel}
            forcePage={page - 1}
        />
    );
};

Pagination.defaultProps = {
    activeClassName: "active",
    breakLabel: "...",
    breakClassName: "break-me",
    containerClassName: "pagination pagination-fix",
    itemsPerPage: 10,
    marginPagesDisplayed: 2,
    nextLabel: "next",
    pageRangeDisplayed: 5,
    previousLabel: "previous",
};

export default memo(Pagination);
